import { render, staticRenderFns } from "./BarMenu.vue?vue&type=template&id=10105669&scoped=true"
import script from "./BarMenu.vue?vue&type=script&lang=js"
export * from "./BarMenu.vue?vue&type=script&lang=js"
import style0 from "./BarMenu.vue?vue&type=style&index=0&id=10105669&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10105669",
  null
  
)

export default component.exports